import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import "./student-council.css";

import Regulations from "./components/Regulations/Regulations";
import RegulationsDetail from "./components/Regulations/RegulationsDetail";
import Template from "./components/Template/Template";
import TemplateDetail from "./components/Template/TemplateDetail";

export default function Std_Council() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();

  const TAB = {
    REG: "regulations",
    TEMPLATE: "template",
  };

  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || TAB.REG
  );

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  const isRegulationsDetail = location.pathname.includes("/regulations/");
  const isTemplateDetail = location.pathname.includes("/template/");

  const handleTabClick = (tab) => {
    setActiveTab(tab);

    navigate("/documents/student-council", {
      state: { activeTab: tab },
    });
  };

  return (
    <>
      <div className="stdcouncil-header">
        <h2 className="stdcouncil-title">총학생회</h2>

        <div className="stdcouncil-tabs">
          <button
            className={activeTab === TAB.REG ? "active" : ""}
            onClick={() => handleTabClick(TAB.REG)}
          >
            회칙/세칙
          </button>

          <button
            className={activeTab === TAB.TEMPLATE ? "active" : ""}
            onClick={() => handleTabClick(TAB.TEMPLATE)}
          >
            게시판
          </button>
        </div>
      </div>

      {id ? (
        <>
          {isRegulationsDetail && <RegulationsDetail />}
          {isTemplateDetail && <TemplateDetail />}
        </>
      ) : (
        <>
          {activeTab === TAB.REG && <Regulations />}
          {activeTab === TAB.TEMPLATE && <Template />}
        </>
      )}
    </>
  );
}